import { blue, neutral, Text } from "@flat-ui";
import { Box, Grid2 } from "@mui/material";
import { ExporterApp } from "@pages/settings/export-workspace/exporter-app";
import { GetToken } from "@pages/settings/export-workspace/get-token";
import { CommonStyles } from "@styles/common-styles";

/** Allows users to get a token to export/download the workspace data */
export function ExportWorkspace(): JSX.Element {
  return (
    <Box
      data-testid="workspace-settings-export-workspace"
      sx={{
        mt: "24px",
        backgroundColor: neutral[50],
        borderRadius: "8px",
        padding: "50px",
      }}
    >
      <Text variant="heading24" component="div" color={blue[400]}>
        Let's export your workspace
      </Text>
      <Text
        variant="bodyL"
        component="div"
        color={neutral[600]}
        sx={{
          marginTop: "8px",
          paddingBottom: "32px",
          borderBottom: CommonStyles.Borders.gray200Divider,
        }}
      >
        Download the code and the app. Open the app and follow the instructions
        to start your export.
      </Text>
      <Grid2
        container
        spacing={2}
        sx={{
          mt: "32px",
          alignItems: "center",
          justifyContent: "space-between",
        }}
      >
        <Grid2
          size={{
            xs: 12,
            sm: "auto",
          }}
        >
          <GetToken />
        </Grid2>
        <Grid2
          size={{
            xs: 12,
            sm: "grow",
          }}
        >
          <ExporterApp />
        </Grid2>
      </Grid2>
    </Box>
  );
}
